import { Collection } from "shared/Collection.js";
import { RevenueHistoryModel } from "shared/models/RevenueHistoryModel.js";

export class RevenueHistoryCollection extends Collection {
  get Model() {
    return RevenueHistoryModel;
  }
}
